import { render, staticRenderFns } from "./SettingsCompany.vue?vue&type=template&id=692ef252&scoped=true"
import script from "./SettingsCompany.vue?vue&type=script&lang=js"
export * from "./SettingsCompany.vue?vue&type=script&lang=js"
import style0 from "./SettingsCompany.vue?vue&type=style&index=0&id=692ef252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692ef252",
  null
  
)

export default component.exports